<template>
  <div :class="{ step: true, 'step--active': active }">
    <div class="step__head">
      <div class="step__head-number">
        {{ number }}
      </div>

      <h2 class="step__head-title">
        <slot name="head"></slot>
      </h2>
    </div>

    <div class="step__content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    number: Number,
    active: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped>
.step {
  transition: opacity .3s ease-out;
}

.step:not(.step--active) {
  pointer-events: none;
  opacity: .3;
}

.step__head {
  background: #bc3736;
  color: #fff;
  font-weight: 700;
  padding: 10px 15px;
  position: relative;
  z-index: 2;
  flex-shrink: 0;
  border-bottom: 1px solid #231f20;
}

.step__head-number {
  border: 2px solid #fff;
  border-radius: 50%;
  width: 2.25rem;
  height: 2.25rem;
  text-align: center;
  font-size: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.step__head-title {
  font-size: 1.125rem;
  margin: 0;
}

.step__content {
  background-color: #fff;
}

@media (max-width: 767px) {
  .step__head {
    display: flex;
    align-items: center;
  }

  .step__head-number {
    margin-right: .75rem;
  }
}

@media (min-width: 768px) {
  .step {
    display: flex;
  }

  .step__head {
    width: 7.5rem;
    height: 8rem;
    padding: .75rem;
  }

  .step__head-number {
    margin-bottom: .5rem;
  }

  .step__content {
    flex-grow: 1;
    border-bottom: 1px solid #d3d3d3;
  }
}
</style>
